import { DRIZZLE_TTY_PROMPT_ERROR } from '@cli-constants/process-output.js'
import { stripAnsi } from '@cli-utils/text.js'

export function createTtyPromptErrorSuppressor(forward: (chunk: string) => void): {
  write: (chunk: string) => void
  sawError: () => boolean
} {
  let inStack = false
  let saw = false

  return {
    write(chunk: string) {
      const lines = chunk.match(/[^\n]*\n|[^\n]+/g) ?? []
      const kept: string[] = []
      for (const line of lines) {
        const text = stripAnsi(line, { stripCarriageReturns: true }).trim()
        if (text.includes(DRIZZLE_TTY_PROMPT_ERROR)) {
          saw = true
          inStack = true
          continue
        }
        if (inStack) {
          if (text.startsWith('at ') || text === '') {
            continue
          }
          inStack = false
        }
        kept.push(line)
      }
      if (kept.length > 0) {
        forward(kept.join(''))
      }
    },
    sawError: () => saw
  }
}
